import React from 'react';
import { NavLink } from 'react-router';
import InsuranceView from './InsuranceView';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter, formatRegistryNumber, infoFormatterIntl,
} from '../../../../utils/formatters';
import { PROCEDURE_TYPE, REGISTRY_TYPE, USER_TYPE } from '../../../../configs';
import OsgopInsuranceView from './OsgopInsuranceView';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function ApplicationCarrierView({ data = {}, currentApplication = {}, fieldsValidation }) {
  const {
    expiration_date,
    order_services_attach = [],
    vehicles_attach,
    vehicles_detach,
    carriage_contract_number,
    order_services_detach,
    carriage_contract_expiration_date,
    carriage_contract_effective_date,
    carriage_contract_name,
    carriage_vehicle_number,
  } = data;
  const hasOrderServices = order_services_attach && order_services_attach.length > 0;
  const {
    osgop_insurance,
    osgop_insurances,
    procedure: currentProcedure,
    registry_subjects = [],
    applicant = {},
    registry_subject_id,
    registry_subject,
    registryType = REGISTRY_TYPE.CARRIER,
    files = [],
    numbers = [],
  } = currentApplication;

  const params = {};
  if (registry_subject_id) {
    params.registry_id = registry_subject_id;
  } else {
    params.numbers = [currentApplication.number];
  }

  const carriage_file = files && files.length ? files.find(item => item.collection_name === 'carriage_file') : undefined;
  const order_service_contract_files = files && files.length ? files.find(item => item.collection_name === 'order_service_contract_files') : undefined;

  return (
    <>
      {currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 && [USER_TYPE.INDIVIDUAL_ENTREPRENEUR, USER_TYPE.LEGAL].includes(applicant.legal_entity_type) ? null : <div className="f4">Номер разрешения перевозчика</div>}
      { currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 && applicant.legal_entity_type === USER_TYPE.PRIVATE_PERSON
        ? (
          <>
            <Row className="row-cols-2">
              {infoFormatterIntl('expiration_date', dateFormatter(expiration_date), fieldsValidation, 'application_carrier.expiration_date')}
            </Row>
            <div className="mb-3" />
          </>
        )
        : currentProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_1
          ? (
            <Row className="row-cols-1">
              {formatRegistryNumber(numbers, registry_subjects, registry_subject, registryType, fieldsValidation, 'carrier')}
              <Row className="row-cols-2">
                {infoFormatterIntl('expiration_date', dateFormatter(expiration_date), fieldsValidation, 'application_carrier.expiration_date')}
              </Row>
            </Row>
          ) : null}
      {
        currentProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_2 && currentProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_3 && currentProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_4 ? (
          <>
            {
              currentProcedure !== PROCEDURE_TYPE.PROCEDURE_1227_1 ? (
                <>
                  <div className="f4 mt-3">Информация по ОСГОП перевозчика</div>
                  {Array.isArray(osgop_insurances) ? (
                    osgop_insurances.map((fields, index) => (
                      <div key={`osgop-insurance-view-${index}`} className="mt-3">
                        <OsgopInsuranceView
                          data={fields}
                          currentApplication={currentApplication}
                          labelPrefix="osgop_"
                          formMeta={fieldsValidation}
                          prefix="osgop_insurances."
                        />
                      </div>
                    ))
                  ) : (
                    <InsuranceView
                      data={osgop_insurance}
                      labelPrefix="osgop_"
                      formMeta={fieldsValidation}
                      prefix="osgop_insurances."
                    />
                  )}
                </>
              ) : null
            }
            {/* {applicant.legal_entity_type === USER_TYPE.PRIVATE_PERSON || applicant.legal_entity_type === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? ( */}
            {/*  <> */}
            {/*    <div className="f4 mt-3">Водительское удостоверение</div> */}
            {/*    <Row className="row-cols-3"> */}
            {/*      {applicant.legal_entity_type === USER_TYPE.INDIVIDUAL_ENTREPRENEUR ? infoFormatterIntl('has_employees', has_employees ? 'Да' : 'Нет', fieldsValidation, 'application_carrier.has_employees') : null} */}
            {/*      {infoFormatterIntl('driver_license_series', driver_license_series, fieldsValidation, 'application_carrier.driver_license_series')} */}
            {/*      {infoFormatterIntl('driver_license_number', driver_license_number, fieldsValidation, 'application_carrier.driver_license_number')} */}
            {/*    </Row> */}
            {/*    <Row className="row-cols-2"> */}
            {/*      {infoFormatterIntl('driver_license_issue_date', dateFormatter(driver_license_issue_date), fieldsValidation, 'application_carrier.driver_license_issue_date')} */}
            {/*      {infoFormatterIntl('driver_license_expiration_date', dateFormatter(driver_license_expiration_date), fieldsValidation, 'application_carrier.driver_license_expiration_date')} */}
            {/*    </Row> */}
            {/*  </> */}
            {/* ) : null} */}
          </>
        ) : null
      }
      {
        currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1
        || currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5
          ? (
            <>
              <div className="f4 mt-3">{ currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 ? 'Номер записи в реестре ЛТ' : 'Номера в реестре ЛТ включить перевозчику' }</div>
              {((vehicles_attach && vehicles_attach.length) ? vehicles_attach : []).map((attach, index) => (
                <Row key={`vehicles-attach-${index}`} className="row-cols-1">
                  {infoFormatterIntl('vehicles_attach', <NavLink target="_blank" to={`/region-registry/passenger-taxi?numbers=${attach?.vehicle_number}`}>{attach?.vehicle_number}</NavLink>, fieldsValidation, `application_carrier.vehicles_attach.${index}.vehicle_number`)}
                </Row>
              ))}
            </>
          ) : null
      }
      {
        (currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1
          || currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5)
          ? (
            <>
              {/* { order_service && Array.isArray(order_service) && order_service?.length ? <div className="f4 mt-3">Реестр СЗЛТ</div> : null } */}
              {/* {order_service.map((item, index) => ( */}
              {/*  <div className="carrier-szlt-registry mt-3" key={`carrier-szlt-registry-${index}`}> */}
              {/*    <CarrierSZLTView data={item} /> */}
              {/*  </div> */}
              {/* ))} */}
              {applicant && applicant.legal_entity_type === USER_TYPE.PRIVATE_PERSON
                ? (
                  <>
                    <div className="f4 mt-3">Информация о договоре об обеспечении</div>
                    <Row className="row-cols-2">
                      {infoFormatterIntl('carriage_contract_name', carriage_contract_name, fieldsValidation, 'application_carrier.carriage_contract_name')}
                      {infoFormatterIntl('vehicle.registry.number', <NavLink target="_blank" to={`/region-registry/passenger-taxi?numbers=${carriage_vehicle_number}`}>{carriage_vehicle_number}</NavLink>, fieldsValidation, 'application_carrier.carriage_vehicle_number')}
                    </Row>
                    <Row className="row-cols-3">
                      {infoFormatterIntl('carriage_contract_number', carriage_contract_number, fieldsValidation, 'application_carrier.carriage_contract_number')}
                      {infoFormatterIntl('carriage_contract_effective_date', dateFormatter(carriage_contract_effective_date), fieldsValidation, 'application_carrier.carriage_contract_effective_date')}
                      {infoFormatterIntl('carriage_contract_expiration_date', dateFormatter(carriage_contract_expiration_date), fieldsValidation, 'application_carrier.carriage_contract_expiration_date')}
                    </Row>
                    <Row className="row-cols-1">
                      {infoFormatterIntl('carriage_file', carriage_file ? <FileView readOnly withoutMime withoutHr files={[carriage_file]} /> : null, fieldsValidation, 'carriage_file', 6)}
                    </Row>
                  </>
                ) : null}
            </>
          ) : null
      }
      {/* { */}
      {/*  currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 || currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5 ? ( */}
      {/*    <> */}
      {/*      <div className="f4 mt-3">{currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_1 ? 'Номер в реестре СЗЛТ' : 'Добавить СЗЛТ'} </div> */}
      {/*      {((hasOrderServices && order_services_attach) || []).map((attach, index) => ( */}
      {/*        <div key={`order-service-attach${index}`}> */}
      {/*          <Row className="row-cols-3"> */}
      {/*            {infoFormatterIntl('order_service_numbers', <NavLink target="_blank" to={`/region-registry/szlt?numbers=${attach?.order_service_number}`}>{attach?.order_service_number}</NavLink>, fieldsValidation, `application_carrier.order_services_attach.${index}.order_service_number`)} */}
      {/*            {infoFormatterIntl('order_service_contract_number', attach?.contract_number, fieldsValidation, `application_carrier.order_services_attach.${index}.contract_number`)} */}
      {/*            {infoFormatterIntl('order_service_contract_effective_date', dateFormatter(attach?.contract_effective_date), fieldsValidation, `application_carrier.order_services_attach.${index}.contract_effective_date`)} */}
      {/*          </Row> */}
      {/*          <Row className="row-cols-3"> */}
      {/*            {infoFormatterIntl('order_service_contract_expiration_date', dateFormatter(attach?.contract_expiration_date), fieldsValidation, `application_carrier.order_services_attach.${index}.contract_expiration_date`)} */}
      {/*            {infoFormatterIntl('media.order_service_contract_files', order_service_contract_files ? <FileView readOnly withoutMime withoutHr files={[order_service_contract_files]} /> : null, fieldsValidation, 'order_service_contract_files', 4)} */}
      {/*          </Row> */}
      {/*        </div> */}
      {/*      ))} */}
      {/*    </> */}
      {/*  ) : null */}
      {/* } */}
      {/* {currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5 ? ( */}
      {/*  <> */}
      {/*    <div className="f4 mt-3">Номера договоров с СЗЛТ исключить от перевозчика</div> */}
      {/*    {((order_services_detach && order_services_detach.length) ? order_services_detach : []).map((attach, index) => ( */}
      {/*      <Row key={`order-service-detach${index}`} className="row-cols-1"> */}
      {/*        {infoFormatterIntl('order_service_numbers_detach', <NavLink target="_blank" to={`/region-registry/szlt?numbers=${attach?.order_service_number}`}>{attach?.order_service_number}</NavLink>, fieldsValidation, `application_carrier.order_services_detach.${index}.order_service_number`)} */}
      {/*      </Row> */}
      {/*    ))} */}
      {/*  </> */}
      {/* ) : null} */}
      {
        currentProcedure === PROCEDURE_TYPE.PROCEDURE_1227_5
          ? (
            <>
              <div className="f4 mt-3">Номера в реестре ЛТ исключить от перевозчика</div>
              {((vehicles_detach && vehicles_detach.length) ? vehicles_detach : []).map((detach, index) => (
                <Row key={`vehicles-detach${index}`} className="row-cols-1">
                  {infoFormatterIntl('vehicle_numbers_detach', <NavLink target="_blank" to={`/region-registry/passenger-taxi?numbers=${detach?.vehicle_number}`}>{detach?.vehicle_number}</NavLink>, fieldsValidation, `application_carrier.vehicles_detach.${index}.vehicle_number`)}
                </Row>
              ))}
            </>
          ) : null
      }
      <div className="mb-3" />
    </>
  );
}
